const banks = {
  PLACEHOLDER: {
    code: '000'
  },
  BANCO_DO_BRASIL: {
    code: '001'
  },
  ITAU: {
    code: '341'
  },
  SANTANDER: {
    code: '033'
  },
  CAIXA_ECONOMICA: {
    code: '104'
  },
  INTER: {
    code: '077'
  },
  AGIPLAN: {
    code: '121'
  },
  SICOOB: {
    code: '756'
  },
  SICREDI: {
    code: '748'
  },
  NU_PAGAMENTO: {
    code: '260'
  },
  BRADESCO: {
    code: '237'
  },
  BANCO_RENDIMENTO: {
    code: '633'
  },
  VOTORANTIM: {
    code: '655'
  },
  TOPAZIO: {
    code: '082'
  },
  NEON: {
    code: '655'
  },
  BANCO_TOPAZIO: {
    code: '082'
  },
  ABC_BRASIL: {
    code: '246'
  },
  STONE: {
    code: '197'
  },
  C6_BANK: {
    code: '336'
  },
  BTG: {
    code: '208'
  }
};

module.exports = banks;
